export default __webpack_public_path__ + "static/media/proeletronic.fd4e2721.jpg";